<template>
  <div class="system-compearing-container">
    <div class="title">
      {{ $t("stats_ratios.title") }}
    </div>
    <div class="percentage-container">
      <div
        v-for="item in ratios"
        :key="item.mode"
        :class="{ 'system-percentage-line': true, [`${item.mode}-line`]: true }"
        :style="`width:${item.percentage}%`"
        v-show="item.percentage > 0"
      ></div>
    </div>
    <div class="text-persentage-container">
      <div
        v-for="item in ratios"
        :key="item.mode"
        :class="{ 'text-pesentage': true, [`${item.mode}-text`]: true }"
        v-show="item.percentage > 0"
      >
        {{ item.mode.toUpperCase() }} - {{ item.percentage }}%
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    ratios: Array,
  },
};
</script>
<style scoped>
.system-compearing-container {
  width: 100%;
  background: #1d1d1b;
  border-radius: 1.333vh;
  padding: 2.22vh;
  margin-top: 3.333vh;
  box-sizing: border-box;
}
.title {
  font-size: 2.777vh;
  line-height: 3.222vh;
  color: #908f8d;
  margin-bottom: 2.222vh;
}
.percentage-container {
  width: 100%;
  height: 3.2222222222222223vh;
  display: flex;
  margin-bottom: 2.222vh;
  border-radius: 0.444vh;
  overflow: hidden;
}
.system-percentage-line {
  height: 3.2222222222222223vh;
}
.system-percentage-line:first-child {
  border-radius: 0.444vh 0 0 0.444vh;
}
.system-percentage-line:last-child {
  border-radius: 0 0.444vh 0.444vh 0;
}
.inside-line {
  background: #129b81;
}
.delivery-line {
  background: #cbd9e6;
}
.preorder-line {
  background: #ffd2a8;
}
.reserve-line {
  background: #aeccc6;
}
.text-persentage-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.text-persentage {
  font-size: 2.222vh;
  line-height: 2.5555555555555554vh;
  color: #129b81;
}
.inside-text {
  color: #129b81;
}
.delivery-text {
  color: #cbd9e6;
}
.preorder-text {
  color: #ffd2a8;
}
.reserve-text {
  color: #aeccc6;
}
</style>
